import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { api, ApiError } from '../../lib/api'
import { money } from '../../lib/format'
import type { InvoiceRow } from '../../lib/types'
import { useToast } from '../../app/Toasts'

export default function InvoicesPage() {
  const navigate = useNavigate()
  const { push } = useToast()
  const [rows, setRows] = useState<InvoiceRow[]>([])
  const [loading, setLoading] = useState(true)

  const load = useCallback(async () => {
    try {
      setRows((await api.listInvoices()).items)
    } catch (e) {
      if (e instanceof ApiError && e.status !== 401) push('error', 'Could not load invoices', e.message)
    } finally { setLoading(false) }
  }, [push])

  useEffect(() => { load() }, [load])


  if (loading) return <div className="skeleton" style={{ height: 260 }} />

  return (
    <div className="card">
      <div className="card-head">
        <span className="card-title">Vendor bills</span>
        <div className="grow" />
        <span className="muted" style={{ fontSize: 12 }}>{rows.length} total</span>
      </div>

      {rows.length === 0 ? (
        <div className="empty">
          <div className="empty-title">No approved invoices yet</div>
          <div>Approve a document and it will appear here.</div>
        </div>
      ) : (
        <div className="table-wrap">
          <table className="data">
            <thead>
              <tr>
                <th>Invoice</th><th>Vendor</th><th className="col-optional">Date</th>
                <th className="num col-optional">Tax</th><th className="num">Total</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  <td className="mono" style={{ fontSize: 12 }}>{row.invoice_number}</td>
                  <td>{row.vendor?.name ?? <span className="muted">—</span>}</td>
                  <td className="col-optional">{row.invoice_date ?? <span className="muted">—</span>}</td>
                  <td className="num col-optional">{money(row.total_tax, row.currency)}</td>
                  <td className="num" style={{ fontWeight: 560 }}>
                    {money(row.grand_total, row.currency)}
                  </td>
                  <td className="num">
                    <div className="row" style={{ justifyContent: 'flex-end' }}>
                      <button
                        className="btn btn-sm"
                        onClick={() => navigate(`/inbox/${row.document_id}/review`)}
                      >
                        Source
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
